import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../constants';
import Button from './ui/button';
import ContactForm from './forms/ContactForm';

const ResidentPeopleFirstSection = () => {
  return (
    <section className="bg-gray-100 pt-12 sm:pt-16 md:pt-20 pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Image with overlaid content box */}
        <div className="max-w-6xl mx-auto">
          {/* Mobile Layout - Stacked */}
          <div className="block sm:hidden">
            <img
              src="/images/image_driven.webp"
              alt="Family working together"
              className="w-full h-auto"
              style={{ height: '300px', objectFit: 'cover' }}
            />
            <div className="bg-white p-6 shadow-lg mx-4 -mt-8 relative z-10 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Driven<br />
                <span style={{ color: '#db0058' }}>by insight.</span>
              </h3>
              
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                We use our own in-house developed rules, complex modelling and algorithms to merge all contributor data into one single view. We continually review the data marketplace to identify new sources of data to increase volume, data accuracy and add additional insight.
              </p>
              
              <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium">
                  Find out more
                </Button>
              </Link>
            </div>
          </div>

          {/* Desktop Layout - Overlay */}
          <div className="hidden sm:block relative">
            <img
              src="/images/image_driven.webp"
              alt="Family working together"
              className="w-full h-auto"
              style={{ height: '650px', objectFit: 'cover' }}
            />
            
            {/* Overlaid Content Box - positioned in middle right */}
            <div className="absolute top-1/2 right-8 transform -translate-y-1/2 bg-white p-6 sm:p-8 md:p-10 shadow-lg max-w-md">
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
                Driven<br />
                <span style={{ color: '#db0058' }}>by insight.</span>
              </h3>
              
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
                We use our own in-house developed rules, complex modelling and algorithms to merge all contributor data into one single view. We continually review the data marketplace to identify new sources of data to increase volume, data accuracy and add additional insight.
              </p>
              
              <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium">
                  Find out more
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Second Image Section with left-positioned text box */}
        <div className="max-w-6xl mx-auto mt-16 sm:mt-20 md:mt-24">
          {/* Mobile Layout - Stacked */}
          <div className="block sm:hidden">
            <img
              src="/images/knowing_growing-1.webp"
              alt="People working together with technology"
              className="w-full h-auto"
              style={{ height: '300px', objectFit: 'cover' }}
            />
            <div className="bg-white p-6 shadow-lg mx-4 -mt-8 relative z-10 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Knowing<br />
                <span style={{ color: '#db0058' }}>is growing.</span>
              </h3>
              
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                The power of knowledge maximises returns on time and investment. The more you know of your customer, the more able you are to create bespoke communications that will increase the likelihood of response and engagement.
              </p>
              
              <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium">
                  Find out more
                </Button>
              </Link>
            </div>
          </div>

          {/* Desktop Layout - Overlay */}
          <div className="hidden sm:block relative">
            <img
              src="/images/knowing_growing-1.webp"
              alt="People working together with technology"
              className="w-full h-auto"
              style={{ height: '650px', objectFit: 'cover' }}
            />
            
            {/* Overlaid Content Box - positioned in middle left */}
            <div className="absolute top-1/2 left-8 transform -translate-y-1/2 bg-white p-6 sm:p-8 md:p-10 shadow-lg max-w-md">
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
                Knowing<br />
                <span style={{ color: '#db0058' }}>is growing.</span>
              </h3>
              
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
                The power of knowledge maximises returns on time and investment. The more you know of your customer, the more able you are to create bespoke communications that will increase the likelihood of response and engagement.
              </p>
              
              <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium">
                  Find out more
                </Button>
              </Link>
            </div>
          </div>
        </div>

      </div>
      
      {/* Third Section - Split layout with two different content areas */}
      <div className="w-full mt-16 sm:mt-20 md:mt-24">
        <div className="flex flex-col md:flex-row h-auto md:h-96">
          {/* Left side - It all begins with insight */}
          <div className="w-full md:w-1/2 text-white p-8 md:p-12 flex flex-col justify-center" style={{ backgroundColor: '#ac1740' }}>
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
              It all begins with <span className="font-normal">insight.</span>
            </h3>
            
            <p className="text-sm sm:text-base leading-relaxed mb-8">
              So, what can you do with all this new insight? And what can you expect to gain from partnering with us? Take a look at some of the businesses we've already supported with our data consultancy service.
            </p>
            
            <Link to="/evidence" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium">
                See our case studies
              </Button>
            </Link>
          </div>
          
          {/* Right side - Data, redefined */}
          <div className="w-full md:w-1/2 text-white p-8 md:p-12 flex flex-col justify-center" style={{ backgroundColor: '#970263' }}>
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
              Data, <span className="font-normal">redefined.</span>
            </h3>
            
            <p className="text-sm sm:text-base leading-relaxed mb-8">
              Data is only ever data, unless it's high quality, accurate and brought to life in the right way. We work closely with our customers to deliver meaningful insight that drives performance and growth – with a service that's tailored to each and every business.
            </p>
            
            <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium">
                Find out more
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Let's Talk Section */}
      <div
        className="pt-8 sm:pt-12 lg:pt-16 pb-16 sm:pb-20 lg:pb-24 px-4 sm:px-8 md:px-16 lg:px-24"
        style={{ backgroundColor: COLORS.secondary }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            {/* Left Column - Let's talk */}
            <div className="text-white max-w-md">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold leading-tight mb-6 sm:mb-8">
                Let's <span style={{ color: '#db0058' }}>talk...</span>
              </h1>
              <div className="space-y-3 sm:space-y-4 text-base sm:text-lg">
                <p>So you're ready to get on board?</p>
                <p>
                  See how Lloyd James could help <strong>unlock the power of your data and take your business further.</strong>
                </p>
              </div>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium" className="mt-6 sm:mt-8">
                  Contact us
                </Button>
              </Link>
            </div>

            {/* Right Column - Enquire now form */}
            <ContactForm
              title="Enquire now"
              webFormId="lloyd_james_resident_form"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResidentPeopleFirstSection;